"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.key = exports.isString = exports.isOrderNumber = exports.isOlderThan = exports.isObject = exports.isInTime = exports.isId = exports.isExpired = exports.isEmptyObject = exports.isEmail = exports.isDate = exports.isArray = exports.includes = exports.ignoreCase = exports.ids = exports.id = exports.hasOne = exports.hasNone = exports.hasMany = exports.hasLength = exports.hasAny = exports.generateCode = exports.generateKey = exports.generateId = exports.formatPrice = exports.formatPercentage = exports.formatDate = exports.findById = exports.findBy = exports.extension = exports.every = exports.ensureArray = exports.deduplicate = exports.createSnsEvent = exports.createGatewayEvent = exports.contains = exports.concat = exports.clone = exports.clean = exports.caseInsensitiveIncludes = exports.caseInsensitiveCompare = exports.capitalize = exports.byId = exports.btoa = exports.basename = exports.atob = exports.areIds = exports.addDate = exports.without = exports.debounce = void 0;
exports.wait = exports.unique = exports.toBoolean = exports.titleCase = exports.test = exports.stringify = exports.splitFullName = exports.split = exports.sortBy = exports.some = exports.sleep = exports.round = exports.remove = exports.randomInRange = exports.random = exports.push = exports.pretty = exports.plural = exports.pick = exports.past = exports.parseSnsMessage = exports.parseGatewayMessage = exports.parseErrorMessage = exports.parseJSON = exports.orderNumber = exports.now = exports.minValue = exports.merge = exports.maxValue = exports.keyify = void 0;
const uuid_1 = require("uuid");
const lodash_1 = require("lodash");
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
// @ts-ignore
var lodash_2 = require("lodash");
Object.defineProperty(exports, "debounce", { enumerable: true, get: function () { return lodash_2.debounce; } });
Object.defineProperty(exports, "without", { enumerable: true, get: function () { return lodash_2.without; } });
function addDate(date, time) {
    if (isString(date))
        date = (0, date_fns_1.parseISO)(date);
    if (time.seconds)
        date = (0, date_fns_1.addSeconds)(date, time.seconds);
    if (time.minutes)
        date = (0, date_fns_1.addMinutes)(date, time.minutes);
    if (time.hours)
        date = (0, date_fns_1.addHours)(date, time.hours);
    if (time.days)
        date = (0, date_fns_1.addDays)(date, time.days);
    return date;
}
exports.addDate = addDate;
// export function addDays(days: number, date = new Date()) {
//
//         if (typeof date === 'string') date = new Date(date);
//
//         let newDate = new Date(date.getTime());
//
//         newDate.setDate(date.getDate() + days);
//
//         return newDate;
//     }
function areIds(ids) {
    if (!ids)
        return false;
    let matches = ids.filter((id) => {
        return id.length === 32;
    });
    return matches.length === ids.length;
}
exports.areIds = areIds;
function atob(data) {
    return Buffer.from(data, 'base64').toString('ascii');
}
exports.atob = atob;
function basename(uri) {
    if (!uri)
        return uri;
    uri = uri.replace(/\\/g, '/');
    let parts = uri.split('/');
    if (!hasAny(parts))
        return;
    let filename = parts[parts.length - 1];
    parts = filename.split('.');
    if (!hasAny(parts))
        return filename;
    let ext = '.' + parts[parts.length - 1];
    return filename.replace(ext, '');
}
exports.basename = basename;
function btoa(data) {
    return Buffer.from(data).toString('base64');
}
exports.btoa = btoa;
/**
 * @deprecated
 * @param items - A collection of objects
 * @param id - The unique identifier on which to match against the 'id' field
 */
function byId(items, id) {
    return (items || []).find((x) => x.id === id);
}
exports.byId = byId;
function capitalize(str) {
    if (!str)
        return str;
    str = str.toString();
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitalize = capitalize;
function caseInsensitiveCompare(str1, str2) {
    return (str1 === null || str1 === void 0 ? void 0 : str1.toLowerCase()) === (str2 === null || str2 === void 0 ? void 0 : str2.toLowerCase());
}
exports.caseInsensitiveCompare = caseInsensitiveCompare;
function caseInsensitiveIncludes(str, arr = []) {
    const lowerStr = str.toLowerCase();
    return arr.some(s => s.toLowerCase() === lowerStr);
}
exports.caseInsensitiveIncludes = caseInsensitiveIncludes;
function clean(val) {
    if (!val || typeof val !== 'string')
        return val;
    return val
        .replace(/\"/g, '\\"')
        .replace(/</g, '[')
        .replace(/>/g, ']');
}
exports.clean = clean;
function clone(value) {
    if (isObject(value))
        return Object.assign({}, value);
    else if (isArray(value))
        return [...value];
    else
        return value;
}
exports.clone = clone;
function concat(a, b, c, d, e, f, g, h, i) {
    let output = [];
    let arrays = Array.from(arguments);
    for (let array of arrays)
        output = output.concat(array);
    return output;
}
exports.concat = concat;
function contains(array, x) {
    if (!array)
        return false;
    return array.indexOf(x) >= 0;
}
exports.contains = contains;
function createGatewayEvent(body, params) {
    let event = {};
    if (body)
        event.body = JSON.stringify(body);
    if (params)
        event.pathParameters = params;
    return event;
}
exports.createGatewayEvent = createGatewayEvent;
function createSnsEvent(message) {
    return {
        Records: [{
                Sns: {
                    Message: JSON.stringify(message)
                }
            }]
    };
}
exports.createSnsEvent = createSnsEvent;
// export function debounce
/**
 * Removes duplicate values from the given array
 * @param array
 */
function deduplicate(array) {
    return Array.from(new Set(array)).filter(Boolean);
}
exports.deduplicate = deduplicate;
function ensureArray(array) {
    if (!array)
        return [];
    if (!Array.isArray(array))
        array = [array];
    return array;
}
exports.ensureArray = ensureArray;
function every(items, predicate) {
    if (!hasAny(items))
        return true;
    return items.length === items.filter(predicate).length;
}
exports.every = every;
// export function extend,
/**
 * Parses the file extension from the given filename, including the '.'
 * @param filename
 */
function extension(filename) {
    if (!filename)
        return '';
    let parts = filename.split('.');
    if (!hasAny(parts))
        return '';
    if (filename === parts[0])
        return '';
    let ext = '.' + parts[parts.length - 1];
    return ext;
}
exports.extension = extension;
// export function find,
/**
 * Finds the first item in a collection of objects that matches the given id
 * @param items - A collection of objects
 * @param prop = The name of the property to match
 * @param value - The value on which to match against the provided property name
 */
function findBy(items, prop, value) {
    return (items || []).find((x) => x[prop] === value);
}
exports.findBy = findBy;
/**
 * Finds the first item in a collection of objects that matches the given id
 * @param items - A collection of objects
 * @param id - The unique identifier on which to match against the 'id' property
 */
function findById(items, id) {
    return (items || []).find((x) => x.id === id);
}
exports.findById = findById;
// export function flatMap,
function formatDate(input, formatTemplate = 'MM/dd/yyyy') {
    try {
        if (!input)
            return input;
        let date;
        if (isDate(input)) {
            date = new Date(input.getTime());
        }
        else if (isString(input)) {
            date = new Date(input);
        }
        if (!date)
            return input;
        switch (formatTemplate) {
            case 'timestamp':
                return (0, date_fns_tz_1.format)(date, 'MM/dd/yyyy h:mm a z');
            case 'relative':
                return (0, date_fns_1.formatDistanceToNow)(date, { addSuffix: true });
            case 'short':
                return (0, date_fns_tz_1.format)(date, 'MM/dd/yyyy');
            case 'friendly':
                return (0, date_fns_tz_1.format)(date, 'MMM do yyyy');
            default:
                return (0, date_fns_tz_1.format)(date, formatTemplate);
        }
    }
    catch (ex) {
        return input;
    }
}
exports.formatDate = formatDate;
function formatPercentage(num) {
    if (!num)
        return "-";
    let value = Math.round(num * 100);
    return value.toString() + "%";
}
exports.formatPercentage = formatPercentage;
function formatPrice(num, precision = 0) {
    if (!num)
        return '-';
    let fix = (Math.floor(num) === num) ? precision : 2;
    return '$' + num.toFixed(fix);
}
exports.formatPrice = formatPrice;
function generateId(iterations = 1) {
    let id = '';
    for (let i = 0; i < iterations; i++) {
        id += (0, uuid_1.v4)().replace(/-/g, '');
    }
    return id;
}
exports.generateId = generateId;
function generateKey(length = 5) {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
}
exports.generateKey = generateKey;
function generateCode(numDigits = 6) {
    const min = Math.pow(10, (numDigits - 1));
    const max = Math.pow(10, numDigits) - 1;
    return (Math.floor(Math.random() * (max - min + 1)) + min).toString();
}
exports.generateCode = generateCode;
function hasAny(items = []) {
    return hasLength(items);
}
exports.hasAny = hasAny;
function hasLength(items = [], min = 1) {
    if (!items)
        return false;
    return !!(items.length >= min);
}
exports.hasLength = hasLength;
function hasMany(items) {
    return hasLength(items, 2);
}
exports.hasMany = hasMany;
function hasNone(items = []) {
    if (!items)
        return true;
    return items.length <= 0;
}
exports.hasNone = hasNone;
function hasOne(items = []) {
    if (!items)
        return false;
    return items.length === 1;
}
exports.hasOne = hasOne;
function id() {
    return (0, uuid_1.v4)().replace(/-/g, '');
}
exports.id = id;
function ids(items = []) {
    items = ensureArray(items);
    items = items.filter(Boolean);
    return deduplicate(items.map((x) => x.id));
}
exports.ids = ids;
function ignoreCase(value) {
    if (value)
        value = value.replace("+", "\\+").replace(".", "\\.");
    const re = "^" + value + "$";
    return new RegExp(re, "i");
}
exports.ignoreCase = ignoreCase;
function includes(items = [], value) {
    if (!hasAny(items))
        return false;
    return items.includes(value);
}
exports.includes = includes;
// export function intersection,
function isArray(value) {
    return Array.isArray(value);
}
exports.isArray = isArray;
function isDate(input) {
    return Object.prototype.toString.call(input) === '[object Date]';
}
exports.isDate = isDate;
function isEmail(email) {
    if (!email)
        return false;
    let re = /(\w+)\@(\w+)\.[a-zA-Z]/g;
    return re.test(email);
}
exports.isEmail = isEmail;
function isEmptyObject(obj) {
    if (!obj)
        return true;
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
}
exports.isEmptyObject = isEmptyObject;
function isExpired(expiresOn, ttl) {
    if (!expiresOn)
        return true;
    if (ttl)
        expiresOn = addDate(expiresOn, ttl);
    if (isString(expiresOn))
        expiresOn = new Date(expiresOn);
    let now = new Date();
    return expiresOn < now;
}
exports.isExpired = isExpired;
function isId(id) {
    if (!id)
        return false;
    return id.length === 32;
}
exports.isId = isId;
function isInTime(date, ttl = {}) {
    if (!date)
        return false;
    if (isString(date))
        date = new Date(date);
    let end = addDate(new Date(), ttl);
    return (0, date_fns_1.isBefore)(date, end) || (0, date_fns_1.isEqual)(date, end);
}
exports.isInTime = isInTime;
function isObject(input) {
    return !!(input &&
        typeof input === 'object' &&
        !isArray(input));
}
exports.isObject = isObject;
function isOlderThan(date, ttl) {
    // make sure we have a valid date
    if (!date)
        return false;
    if (isString(date))
        date = new Date(date);
    let end = (ttl) ? addDate(new Date(), ttl) : new Date();
    return (0, date_fns_1.isBefore)(date, end) || (0, date_fns_1.isEqual)(date, end);
}
exports.isOlderThan = isOlderThan;
function isOrderNumber(input) {
    if (!input)
        return false;
    const re = /^[0-9A-Z]{6,12}$/ig;
    return re.test(input);
}
exports.isOrderNumber = isOrderNumber;
function isString(input) {
    return !!(input && typeof input === 'string');
}
exports.isString = isString;
function key(length = 5) {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
}
exports.key = key;
// export function keyBy,
function keyify(value) {
    if (!value)
        return value;
    return value.toLowerCase().replace(/[^a-zA-Z\d\s:]/g, "").replace(/ /g, "-");
}
exports.keyify = keyify;
function maxValue(arr) {
    if (!Array.isArray(arr) || arr.length === 0) {
        throw new Error('Input must be a non-empty array');
    }
    return arr.reduce((highest, current) => {
        return (current > highest) ? current : highest;
    }, arr[0]);
}
exports.maxValue = maxValue;
function merge(list = [], updates = [], prop = 'id') {
    list = ensureArray(list);
    if (!hasLength(updates))
        return list;
    updates.forEach(update => {
        let source = list.find(x => update[prop] === x[prop]);
        if (source)
            Object.assign(source, update);
        else
            list.push(update);
    });
    return list;
}
exports.merge = merge;
function minValue(arr) {
    if (!Array.isArray(arr) || arr.length === 0) {
        throw new Error('Input must be a non-empty array');
    }
    return arr.reduce((lowest, current) => {
        return (current < lowest) ? current : lowest;
    }, arr[0]);
}
exports.minValue = minValue;
function now() {
    return new Date();
}
exports.now = now;
function orderNumber(len = 8) {
    const possible = "0123456789ABCDEFGHJKLMNPQRSTUVWXYZ";
    let text = "";
    for (let i = 0; i < (len || 8); i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
exports.orderNumber = orderNumber;
function parseJSON(input) {
    try {
        if (!input)
            return input;
        if (!isString(input))
            return input;
        return JSON.parse(input);
    }
    catch (err) {
        return input;
    }
}
exports.parseJSON = parseJSON;
function parseErrorMessage(err) {
    if (!err)
        return;
    if (typeof err === 'string') {
        return err;
    }
    else if (err instanceof Error || err.message) {
        return err.message;
    }
    else if (err.data && err.data.message) {
        return err.data.message;
    }
}
exports.parseErrorMessage = parseErrorMessage;
function parseGatewayMessage(event = {}) {
    return {
        body: parseJSON(event.body || '{}'),
        headers: event.headers || {},
        params: event.pathParameters || {}
    };
}
exports.parseGatewayMessage = parseGatewayMessage;
function parseSnsMessage(event = {}) {
    if (!event.Records || !event.Records.length)
        return {};
    let record = event.Records[0];
    if (!record.Sns)
        return {};
    let message = record.Sns.Message;
    if (!message)
        return {};
    return JSON.parse(message);
}
exports.parseSnsMessage = parseSnsMessage;
function past(num, name = 'h') {
    num = -num;
    let now = new Date();
    let later = new Date();
    switch (name) {
        case 'min':
        case 'mins':
        case 'm':
            later.setMinutes(now.getMinutes() + num);
            break;
        case 'hour':
        case 'hours':
        case 'h':
            later.setHours(now.getHours() + num);
            break;
    }
    return later;
}
exports.past = past;
function pick(obj, keys) {
    let result = {};
    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let value = obj[key];
        if (value !== undefined)
            result[key] = obj[key];
    }
    return result;
}
exports.pick = pick;
function plural(word = '', count = 1, suffix = 's') {
    if (count === 1)
        return word;
    if (suffix === 'ies' && word.endsWith('y')) {
        word = word.slice(0, -1);
    }
    return word + suffix;
}
exports.plural = plural;
function pretty(obj = {}, indent = 4) {
    try {
        return JSON.stringify(obj, null, indent);
    }
    catch (err) {
        return JSON.stringify({}, null, indent);
    }
}
exports.pretty = pretty;
function push(array = [], insert, uniq = true) {
    if (!insert)
        return;
    if (!isArray(array)) {
        return (isArray(insert)) ? insert : [insert];
    }
    const push = (x) => {
        if (!uniq || !contains(array, x))
            array.push(x);
    };
    isArray(insert) ?
        insert.forEach(push) :
        push(insert);
    return array;
}
exports.push = push;
// push(array: any[] = [], value: any) {
//
//     if (array.includes(value)) return array;
//
//     array.push(value);
//
//     return array;
// }
function random(max = 100) {
    return Math.floor(Math.random() * Math.floor(max));
}
exports.random = random;
function randomInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
exports.randomInRange = randomInRange;
// export function reduce,
function remove(array = [], value) {
    return array.filter((item) => item !== value);
}
exports.remove = remove;
function round(num, i = 2) {
    return parseFloat(num.toFixed(i));
}
exports.round = round;
function sleep(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => setTimeout(resolve, ms));
    });
}
exports.sleep = sleep;
function some(array, predicate) {
    return !!(array.find(predicate));
}
exports.some = some;
function sortBy(arr, prop, desc = false) {
    if (!arr || !arr.length)
        return arr;
    return arr.sort((a, b) => {
        if (desc)
            return (a[prop] < b[prop]) ? 1 : -1;
        return (a[prop] > b[prop]) ? 1 : -1;
    });
}
exports.sortBy = sortBy;
function split(str, delimiter = ',') {
    if (typeof str !== 'string')
        return str;
    if (str.indexOf(delimiter) < 0)
        return str;
    let split = str.split(delimiter) || [];
    return deduplicate(split);
}
exports.split = split;
function splitFullName(fullName) {
    const trimmedName = fullName.trim().replace(/\s+/g, ' ');
    const lastSpaceIndex = trimmedName.lastIndexOf(' ');
    if (lastSpaceIndex === -1) {
        return { firstName: trimmedName, lastName: '' };
    }
    const firstName = trimmedName.substring(0, lastSpaceIndex);
    const lastName = trimmedName.substring(lastSpaceIndex + 1);
    return { firstName, lastName };
}
exports.splitFullName = splitFullName;
function stringify(input, size) {
    try {
        if (!input)
            return input;
        if (isString(input))
            return input;
        return (size) ? JSON.stringify(input, null, size) : JSON.stringify(input);
    }
    catch (err) {
        return input;
    }
}
exports.stringify = stringify;
function test(str, re, word = false, flags) {
    if (!str && !re)
        return true; // if both are falsy, consider them matching
    if (!str || !re)
        return false; // if only one is missing, there can't possibly be a match
    if (word)
        re = "^" + re + "$";
    if (flags === undefined)
        flags = 'i';
    const regex = new RegExp(re, flags);
    return regex.test(str);
}
exports.test = test;
function titleCase(str) {
    if (!str)
        return str;
    return (0, lodash_1.startCase)((0, lodash_1.camelCase)(str));
}
exports.titleCase = titleCase;
function toBoolean(value) {
    if (!value)
        return false;
    if (isString(value)) {
        return (value.toString().toLowerCase() === 'true');
    }
    else
        return !!(value);
}
exports.toBoolean = toBoolean;
// export function uniqBy,
function unique(prefix = '', suffix = '') {
    let ticks = (new Date).getTime();
    return `${prefix}${ticks}${suffix}`;
}
exports.unique = unique;
function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.wait = wait;
// export function without
